export default __webpack_public_path__ + "static/media/blog-post-layout-03-img-03.9f68cd43.jpg";